import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Homepage from './Pages/Homepage';
import Secondpage from './Pages/Secondpage';
import Profile from './Pages/Profile';
import Policy from './components/policy';
import CookiePolicy from './components/CookiePolicy';
import CookieConsent from './components/CookieConsent';
import FindPractitioners from './Pages/Find-practitioners';
import PractitionerList from './Pages/PractitionerList';
import ContactUs from './Pages/Contact';
import DoctorSignup from './Pages/DoctorSignup';
import ClinicSignup from './Pages/ClinicSignup';
import Payment from './components/Payment';
import ClinicDetails from "./Pages/ClinicDetails";
import AppointmentBookedModal from "./Pages/AppointmentBookedModal";
import FaviconManager from './components/FaviconManager';
import { useFavicon } from './hooks/useFavicon';
import ChatWidget from './components/ChatWidget';
import { ChatWidgetProvider } from './context/ChatWidgetContext';

function AppContent() {
  useFavicon(); // This will trigger favicon updates on route changes
  
  return (
    <div className="App">
      <FaviconManager />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/practitioners" element={<Secondpage />} />
        <Route path="/find-practitioners" element={<FindPractitioners />} />
        <Route path="/practitioner-list" element={<PractitionerList />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/profile/:doctorId" element={<Profile />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/doctor-signup" element={<DoctorSignup />} />
        <Route path="/clinic_register" element={<ClinicSignup />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/clinic-details/:id" element={<ClinicDetails />} />
        <Route path="/appointment-booked/:id" element={<AppointmentBookedModal />} />
      </Routes>
      <ChatWidget />
      <CookieConsent />
    </div>
  );
}

function App() {
  return (
    <ChatWidgetProvider>
      <Router>
        <AppContent />
      </Router>
    </ChatWidgetProvider>
  );
}

export default App;
